// extracted by mini-css-extract-plugin
export var flex = "choiceTires-module--flex--Bivio";